import React, { Component } from 'react';
import './A3.css';

class A3 extends Component{
    render(){
        return(    
        <div className="campoA3" >{this.props.children}
        </div>
        )
    }

}

export default A3;